import { graphql } from 'gql.tada';

// --- Backoffice namespace ---

export const GET_SELLERS = graphql(`
    query searchSellers(
        $filter: SellerSearchFilterInput,
        $orderBy: SellerSearchOrderByInput,
        $pagination: SellerSearchPaginationInput
    ) {
        sellers {
            backoffice(
                filter: $filter,
                orderBy: $orderBy,
                pagination: $pagination
            ) {
                count
                items {
                    identifier {
                        sku
                        id
                    }
                    legalName
                    contactEmail
                    contactName
                    postalAddress
                    billingEmail
                    vatId
                    commissionRate
                    walletBalance
                    payoutTemplate
                    businessProvider {
                        identifier {
                            id
                        }
                    }
                }
            }
        }
    }
`);

export const GET_SELLER_SUMMARY = graphql(`
    query sellerSummary($id: UUID) {
        seller(id: $id) {
            backoffice {
                legalName
            }
        }
    }
`);

export const UPDATE_SELLER = graphql(`
    mutation updateSeller(
        $id: UUID!,
        $input: UpdateSellerInput!
    ) {
        seller {
            backoffice {
                update(id: $id, input: $input) {
                    identifier {
                        id
                        sku
                    }
                }
            }
        }
    }
`);

export const CREATE_SELLER = graphql(`
    mutation createSeller(
        $input: CreateSellerInput!
    ) {
        seller {
            backoffice {
                create(input: $input) {
                    identifier {
                        id
                        sku
                    }
                }
            }
        }
    }
`);

export const WITHDRAW_SELLER_WALLET = graphql(`
    mutation walletWithdraw($sellerId: UUID) {
        walletWithdraw(sellerId: $sellerId)
    }
`);

// --- Account namespace (webapp usage) ---

export const GET_SELLER_PROFILE = graphql(`
    query sellerProfile($id: UUID) {
        seller(id: $id) {
            account {
                legalName
                postalAddress
                billingEmail
                vatId
                contactEmail
                contactName
            }
        }
    }
`);

export const GET_SELLER_AUTH_CONTEXT = graphql(`
    query sellerAuthContext {
        seller {
            account {
                identifier {
                    id
                }
                contactName
                contactEmail
            }
        }
    }
`);

export const GET_SELLER_DASHBOARD_METRICS = graphql(`
    query sellerDashboardMetrics($id: UUID) {
        seller(id: $id) {
            account {
                metrics {
                    licensesQuantity
                    programsDuration
                    sourceFilesQuantity
                    walletBalance
                }
            }
        }
    }
`);

export const UPDATE_SELLER_ACCOUNT = graphql(`
    mutation updateSellerAccount(
        $input: UpdateSellerAccountInput!
    ) {
        seller {
            account {
                update(input: $input) {
                    identifier {
                        id
                        sku
                    }
                }
            }
        }
    }
`);
